import MoneyTransferWidget from '@/components/MoneyTransferWidget'

const Index = () => {
  return (
    <div className="min-h-screen bg-transparent flex items-center justify-center p-4">
      <MoneyTransferWidget />
    </div>
  )
}

export default Index
